/* eslint-disable no-use-before-define */
import { wechatShareConfig, loadScript } from '@front-end/utils';
import JsBridge from '@/plugins/jsBridge';
import { device } from './device';

const bridge = new JsBridge();

const DEFAULT_ICON = 'https://www.jin10.com/activitys/ttps/img/share.jpg';
const DEFAULT_CONTENT = '金十数据';
const DEFAULT_TITLE = '金十数据';

export function setShare(options = {}) {
  const param = {
    title: DEFAULT_CONTENT,
    content: DEFAULT_TITLE,
    icon: DEFAULT_ICON,
    ...options,
  };
  setAppShareConfig(param);
  setWechatConfig(param);
  setDingTalk(param);
  setMeta(param);
}

/** APP分享配置 */
function setAppShareConfig({
  title,
  content,
  icon,
}) {
  if (bridge.isApp) {
    bridge.dispatch('modifyAppShareUrl', {
      url: window.location.href,
      title,
      subTitle: content,
      icon,
    });
  }
}

/** 微信分享配置 */
function setWechatConfig({
  title,
  content,
  icon,
}) {
  wechatShareConfig({
    title,
    desc: content,
    link: window.location.href,
    imgUrl: icon,
    onShareSuccess() {},
    onShareCancel() {},
  });
}

/** index.html head meta 配置 */
function setMeta({
  content,
}) {
  const descMeta = document.querySelector('meta[name^=description]');
  if (descMeta) {
    descMeta.content = content;
  }
}

function setDingTalk({
  title,
  content,
}) {
  if (!device.isDingTalk) return;

  loadScript('https://g.alicdn.com/dingding/open-develop/1.9.0/dingtalk.js').then(() => {
    window.dd.ready(() => {
      window.dd.biz.navigation.setRight({
        show: true, // 控制按钮显示， true 显示， false 隐藏， 默认true
        control: true, // 是否控制点击事件，true 控制，false 不控制， 默认false
        text: '...', // 控制显示文本，空字符串表示显示默认文本
        onSuccess() {
          // 如果control为true，则onSuccess将在发生按钮点击事件被回调
          window.dd.biz.util.share({
            type: 0, // 分享类型，0:全部组件 默认； 1:只能分享到钉钉；2:不能分享，只有刷新按钮
            url: window.location.href,
            content,
            title,
            image: 'https://www.jin10.com/activitys/ttps/img/share.jpg',
            onSuccess() {
              // onSuccess将在分享完成之后回调
              /**/
            },
            onFail() { },
          });
        },
        onFail() { },
      });
    });
  });
}
